import styled from 'styled-components';

import fonts from '../../ui/fonts';
import { colors } from '../../ui/design-tokens';
import { media, space, rems } from '../../ui/helpers';
import { MAIN_MENU_HEIGHT, SUB_MENU_HEIGHT } from '../../ui/settings';

const CTAContainerFooter = styled.div`
  align-items: center;
  display: none;
  ${media.max('medium')`
    display: flex;
    background: ${colors.neutral[100]};
    bottom: 0;
    justify-content: center;
    left: 0;
    padding: ${space(2)} ${space(5)};
    position: fixed;
    width: 100vw;
    z-index: 10000;
  `};

  .franchiseCta {
    background: ${colors.neutral[100]};
    border-color: none;
    color: ${colors.babies[900]};

    &:hover {
      background: ${colors.babies[300]};
      border-color: ${colors.babies[300]};
    }
  }

  &.has-hubspot-button {
    a {
      width: calc(100% - 96px - 1.5rem);
    }
  }
`;
const CTAContainer = styled.div`
  align-items: center;
  display: flex;

  ${media.max('medium')`
    display:none;
  `};

  .franchiseCta {
    background: ${colors.neutral[100]};
    border-color: none;
    color: ${colors.babies[900]};

    &:hover {
      background: ${colors.babies[300]};
      border-color: ${colors.babies[300]};
    }
  }

  &.has-hubspot-button {
    a {
      width: calc(100% - 96px - 1.5rem);
    }
  }
`;

const SecondaryContainer = styled.div`
  background: ${colors.neutral[100]};
  position: relative;
  z-index: 3;

  &.for-desktop {
    display: none;
  }

  ${media.min('medium')`
    &.for-mobile { display: none; }
    &.for-desktop { display: flex; }
  `};
`;

const Secondary = styled.div`
  color: ${colors.neutral[800]};
  pointer-events: initial;

  a,
  button {
    path {
      fill: currentColor;
    }
  }

  .links {
    a {
      ${fonts.bodyXSM};
      font-weight: 500 !important;
    }
  }

  ${media.min('medium')`
    align-items: center;
    height: ${rems(SUB_MENU_HEIGHT)};
    width: 100%;

    .links {
      height: 100%;
      justify-content: flex-end;

      li {
        margin-left: ${space(3)};
      }
    }

    a, button {
      color: ${colors.neutral[800]} !important;

      &:hover {
        color: ${colors.primary[500]};
      }
    }
  `};
`;

const Primary = styled.div`
  position: relative;
  z-index: 3;
`;

const StyledLink = styled.li`
  position: relative;
  width: 100%;

  a,
  button {
    ${fonts.bodySM};
    text-decoration: none;
    white-space: nowrap;
  }

  .current {
    > span {
      font-weight: bold;
    }
  }

  .chevron {
    height: ${rems(7)};
    margin-left: auto;
    transition: 0.25s ease-in-out;
    width: ${rems(14)};
    will-change: transform;

    path {
      fill: currentColor;
    }

    &.active {
      transform: rotate(180deg);
    }
  }

  .icon {
    height: ${rems(18)};
    margin-right: ${space(1)};
    width: ${rems(18)};
  }

  &.active.root {
    padding-bottom: 0;
  }

  ${media.max('medium')`
    a, button {
      align-items: center;
      display: flex;
    }
  `};

  ${media.min('medium')`
    align-items: center;
    display: flex;
    width: auto;

    a, button {
      margin: 0;
    }

    &.primary {
      > a,
      > button {
        color: ${colors.neutral[100]};

        .is-sticky & {
          color: ${colors.neutral[900]};
        }
      }
    }

    .chevron {
        margin-left: ${space(1)};
    }

    &:hover {
        .chevron {
            transform: rotate(180deg);
        }
    }
    .highlight{
      -webkit-box-align: center;
      align-items: center;
      border: 2px solid ${colors.neutral[100]};
      cursor: pointer;
      display: inline-flex;
      -webkit-box-pack: center;
      justify-content: center;
      padding: 0.25rem 0.25rem;
      text-decoration: none;
      transition: all 0.1s ease-out 0s;
      vertical-align: text-top;
      width: auto;
      will-change: background, color;
      background: ${colors.neutral[100]};
      color: ${colors.primary[200]} !important;
      font-family: Arial, sans-serif;
      font-size: 0.875rem;
      font-weight: 500 !important;
      letter-spacing: 0rem;
      line-height: 1.1;
      white-space: nowrap;
    }
  `};
`;

const Dropdown = styled.div`
  display: none;

  ${StyledLink}.active > & {
    display: block;
  }

  ul {
    ${StyledLink} {
      background: ${colors.neutral[200]};
    }
  }

  &.second-level ${StyledLink} {
    background: ${colors.neutral[300]};

    a,
    button {
      padding-right: ${space(6)};
    }
  }

  ${media.min('medium')`
    background: none;
    right: 0;
    margin-top: 0;
    pointer-events: none;
    position: absolute;
    top: 100%;

    a, button {
      color: ${colors.neutral[800]};
      padding: ${space(2)};
    }

    &.second-level ${StyledLink} {
      background: ${colors.neutral[200]};
    }

    &.primary-last {
      left: auto;
      right: 0;
    }

    ul ${StyledLink} {
      &:hover {
          .chevron path {
            fill: ${colors.primary[500]};
          }
      }

      .chevron {
          transform: rotate(270deg);

          path {
            fill: ${colors.neutral[800]};

            &:hover {
              fill: ${colors.primary[500]};
            }
          }
      }
    }

    ${StyledLink}.active > &.second-level > ul > ${StyledLink} {
      background: ${colors.neutral[400]};
    }

    ${StyledLink}.active > & {
      display: block;
      margin-top: auto;
    }

    ${StyledLink}:hover {
      background: ${colors.neutral[300]};

      > a {
        color: ${colors.primary[500]};
      }
    }

    ${StyledLink}:hover > & {
      display: block;
      transform: translate(0, 0);
      pointer-events: auto;
      white-space: nowrap;
    }

    &.second-level {
      top: 0;
      right: 100%;
    }

    /* &.second-level.last {
      width: 100%;
      top: 0;
      left: -100%;
    } */

    ${StyledLink}.last {
      .chevron {
        transform: rotate(90deg);
      }
    }
  `};
`;

const Nav = styled.div`
  z-index: 1080;

  ${media.max('medium')`
    background: ${colors.neutral[100]};
    height: calc(100vh - ${rems(MAIN_MENU_HEIGHT)});
    left: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    position: fixed;
    top: ${rems(MAIN_MENU_HEIGHT)};
    transition: left 0.65s ease-in-out;
    width: 100%;
    will-change: left;

    &.open {
      left: 0;
    }

    .links {
      a,
      button {
        border-bottom: 1px solid hsla(0, 100%, 0%, 0.06);
        padding: ${space(3)};
        text-align: left;
        width: 100%;
      }
    }
  `};

  ${media.min('medium')`
    display: flex;
    justify-content: flex-end;
    margin-left: auto;

    .links > li, .cta {
      margin-left: ${space(4)};
    }

    a, button {
      &::not(.cta) {
        height: ${rems(MAIN_MENU_HEIGHT)};
      }
    }
  `};
`;

const Hamburger = styled.div<{ sticky: boolean }>`
  margin-left: auto;
  width: ${rems(26)};

  ${media.min('medium')`
    display: none;
  `}

  span {
    background: currentColor;
    color: ${({ sticky }) => (sticky ? colors.neutral[900] : colors.neutral[100])};
    display: block;
    height: ${rems(3)};
    position: absolute;
    top: ${space(5)};
    transition: 0.5s;
    width: ${rems(26)};

    &:before,
    &:after {
      background: currentColor;
      content: '';
      height: inherit;
      position: absolute;
      transition: 0.5s;
      width: inherit;
    }

    &:before {
      transform: translateY(-8px);
    }

    &:after {
      transform: translateY(8px);
    }
  }

  .text {
    ${fonts.bodyXSM};
    display: none;
    color: ${colors.neutral[900]};
    margin-top: ${rems(12)};
  }

  &.open {
    span {
      background: transparent;

      &:before {
        transform: translateY(0) rotate(-45deg);
      }
      &:after {
        transform: translateY(0) rotate(45deg);
      }
    }
  }
`;

const LogoContainer = styled.div<{ sticky: boolean }>`
  align-items: center;
  display: flex;

  a {
    display: flex;
    flex: 1;
    height: 100%;
    align-items: center;
  }

  img {
    height: 6.5rem;
    padding-bottom: 0.5rem;

    ${media.max(1060)`
      height: 4rem;
      padding-bottom: 0;
    `}

    ${media.max('medium')`
      height: 4.5rem;
      padding-bottom: 0;
    `}
  }

  svg {
    height: ${space(2.75)};
    width: 100%;

    path {
      ${({ sticky }) => (sticky ? '' : 'fill: ' + colors.neutral[100])};
    }

    ${media.min('medium')`
      transition: height 0.4s ease-in-out;
      height: ${({ sticky }) => (sticky ? space(2.5) : space(3.75))};
      will-change: height;
    `}
  }
`;

const Container = styled.div<{ sticky: boolean }>`
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1080;

  .wrapper {
    display: flex;
  }

  ${media.min('medium')`
    .links {
      display: flex;
      height: 100%;
    }
  `};

  .sticky {
    background: ${({ sticky }) => (sticky ? colors.neutral[100] : 'transparent')};
    display: flex;
    height: ${rems(MAIN_MENU_HEIGHT)};
    pointer-events: initial;
    position: sticky;
    top: 0;
    transition: background 0.25s ease-in-out;
    will-change: background;
    .headLogo-c{
      display: ${({ sticky }) => (sticky ? '' : 'none')};
    }
    .headLogo-bw{
      display: ${({ sticky }) => (sticky ? 'none' : '')};
    }
    ${media.min('medium')`
      margin-top: ${space(2)};

      /* Fix for margin of sticky menu */
      &::before {
        background: ${colors.neutral[100]};
        bottom: 100%;
        content: '';
        display: block;
        height: ${space(2)};
        left: 0;
        opacity: ${({ sticky }) => (sticky ? 1 : 0)};
        position: absolute;
        transition: opacity 0.25s ease-in-out;
        width: 100%;
        will-change: opacity;
      }
    `};
  }
`;

export {
  Container,
  CTAContainer,
  CTAContainerFooter,
  Dropdown,
  Hamburger,
  LogoContainer,
  Nav,
  Primary,
  Secondary,
  SecondaryContainer,
  StyledLink
};
